import { getPrefixEndpoints } from "src/utils";
import apiAuth, { returningError } from "../apiAuth";
import { store } from "src/redux";

export const getWallets = async (code?:string) => {
   try {
      const { data }: any = await apiAuth.get(`/${getPrefixEndpoints(store.getState().app.locale)}/v1/wallets${code !== undefined ? `/${code}` : ''}`,{
            headers: {
                'Authorization': `Bearer ${process.env.REACT_APP_AUTH_TKN}`
            }
      });
      return { ...data, success: 'true' };
   } catch (error: any) {
      return returningError(error);
   }
};

